import React from 'react';
import LevelingRankPicker from './LevelingRankPicker';

export default class Leveling1To40 extends React.PureComponent {
    static minValue = 1;
    static maxValue = 40;

    static describeRank = rank => rank.toString();
    static getDefaultValue = () => [25, 40];

    static marks = {
        1: '1',
        10: '10',
        20: '20',
        25: '25',
        30: '30',
        40: '40',
    };

    render() {
        const { ...rest } = this.props;

        return (
            <LevelingRankPicker
                {...rest}
                min={Leveling1To40.minValue}
                max={Leveling1To40.maxValue}
                marks={Leveling1To40.marks}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/levelingRankPicker/Leveling1to40.js